import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  wrapper: {
    display: 'flex',
    marginRight: 20,
    marginBottom: 20,
    [breakpoints.down(769)]: {
      display: 'block',
      marginBottom: 0,
    },
  },
  title: {
    fontWeight: 700,
    fontSize: 15,
    [breakpoints.down(769)]: {
      display: 'none',
    },
  },
  items: {
    display: 'flex',
    flexWrap: 'wrap',
    [breakpoints.down(769)]: {
      flexDirection: 'column',
    },
  },
}));
